import { Box, Grid, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import SelectOptionsApiAuto from "../../../components/selectAutocomplete";
import { api } from "../../../config/apis";
import AdminApi from "../../../config/apis/admin";
import { DataLoader } from "../../../helper/helperFunction";
import { formatToK } from "../dashboard-cards/formatCurrency";
import dashStyles from "../Dashboard/style.module.css";
import { YEAR_OPTIONS } from "./filter-options";
import { buildSponsorParams } from "./filter-params";
import {
  AmountSpentIcon,
  AmountSponsoredIcon,
  JobPlacementsIcon,
  PassingRatioIcon,
  SponsoredStudentsIcon,
} from "./icons";
import { SponsoredStudents } from "./sponsored-students";
import StatCard from "./stat-card";
import styles from "./style.module.css";
import YearMultiSelect from "./year-multi-select";

const SponsorData = () => {
  const [filterData, setFilterData] = useState({ year: [] });
  const [stats, setStats] = useState();
  const [loading, setLoading] = useState(true);

  const handleUpdate = (name, value) => {
    setFilterData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  useEffect(() => {
    const fetchSummary = async () => {
      try {
        setLoading(true);
        const res = await api.get(AdminApi.DASH_SPONSOR_DATA_SUMMARY, {
          params: buildSponsorParams(filterData),
        });
        setStats(res.data.data);
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    fetchSummary();
  }, [filterData]);

  const cards = [
    {
      title: "No of Sponsored Students",
      value: stats?.sponsored_students ?? 0,
      icon: <SponsoredStudentsIcon />,
      lg: 4,
    },
    {
      title: "Total Amount Spent",
      value: formatToK(Number(stats?.total_amount_spent ?? 0)),
      icon: <AmountSpentIcon />,
      lg: 4,
    },
    {
      title: "Job Placements",
      value: stats?.job_placements ?? 0,
      icon: <JobPlacementsIcon />,
      lg: 4,
    },
    {
      title: "Passing Ratio",
      value: `${stats?.passing_ratio?.passed ?? 0}/${
        stats?.passing_ratio?.retained ?? 0
      }`,
      icon: <PassingRatioIcon />,
      lg: 6,
    },
    {
      title: "Total Amount Sponsored",
      value: formatToK(Number(stats?.total_amount_sponsored ?? 0)),
      icon: <AmountSponsoredIcon />,
      lg: 6,
    },
  ];

  return (
    <Box className="container">
      <Grid container sx={{ justifyContent: "space-between" }}>
        <Grid item xs={3}>
          <Typography variant="h2" className={dashStyles.main_heading}>
            Sponsor Data
          </Typography>
        </Grid>

        <Grid item xs={9}>
          <Box className={styles.filter_wrap}>
            <Typography variant="body2">Organization</Typography>
            <Box className={styles.org_box}>
              <SelectOptionsApiAuto
                apiEndpoint={AdminApi.ORGANIZATIONS}
                formData={filterData}
                onUpdate={handleUpdate}
                labelKey="name"
                valueKey="id"
                name="organization_id"
                errorText=""
                paramId={""}
                defaultText="Select Organization"
              />
            </Box>
            <Typography variant="body2">Cohort</Typography>
            <Box className={styles.cohort_box}>
              <SelectOptionsApiAuto
                apiEndpoint={AdminApi.COHORTS}
                formData={filterData}
                onUpdate={handleUpdate}
                labelKey="title"
                valueKey="id"
                name="cohort_id"
                errorText=""
                paramId={""}
                defaultText="Select Cohort"
              />
            </Box>
            <Typography variant="body2">Year</Typography>
            <Box className={styles.year_box}>
              <YearMultiSelect
                options={YEAR_OPTIONS}
                formData={filterData}
                onUpdate={handleUpdate}
                labelKey="name"
                valueKey="id"
                name="year"
                defaultText="Select Year"
              />
            </Box>
          </Box>
        </Grid>
      </Grid>

      {loading ? (
        <DataLoader />
      ) : (
        <Grid container spacing={3.5} className={styles.cards_wrap}>
          {cards.map((card) => (
            <Grid item xs={12} md={6} lg={card.lg} key={card.title}>
              <StatCard title={card.title} value={card.value} icon={card.icon} />
            </Grid>
          ))}
        </Grid>
      )}

      <SponsoredStudents sponsorFilters={filterData} />
    </Box>
  );
};

export default SponsorData;
